import React, { Component } from "react";
import DashHeaderContainer from "../CommonComponents/Header/HeaderContainer";

class MainLayout extends Component {
  render() {
    return (
      <div>
        <DashHeaderContainer history={this.props.history} />
        {this.props.children}
      </div>
    );
  }
}

export default MainLayout;
